/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonatsauswertungLayoutDto } from '../../models/monatsauswertung-layout-dto';

export interface GetAllMonatsauswertungLayouts$Plain$Params {
}

export function getAllMonatsauswertungLayouts$Plain(http: HttpClient, rootUrl: string, params?: GetAllMonatsauswertungLayouts$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MonatsauswertungLayoutDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllMonatsauswertungLayouts$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MonatsauswertungLayoutDto>>;
    })
  );
}

getAllMonatsauswertungLayouts$Plain.PATH = '/v1/monatsauswertungen/layouts';
